import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Icon } from '@mch-group/uikit-components'

const Directors = ({ directors }) =>
  (directors && directors.length ? (
    <ul>
      {directors.map(director => (
        <li key={director.id}>
          <a href={`mailto:${director.email}`}>
            <Icon name='mail' />
            {director.firstName} {director.lastName}
          </a>
        </li>
      ))}
    </ul>
  ) : null)

Directors.propTypes = {
  directors: PropTypes.array
}

export default styled(Directors)`
  &&& {
    list-style: none;
    padding: 0;

    li {
      a {
        display: flex;
        align-items: center;
        width: fit-content;
        padding-right: 10px;

        svg {
          width: 25px;
          padding: 2px;
          margin-right: 5px;
        }
      }
    }
  }
`
